import React, { Component, Children, cloneElement } from 'react';
import _get from 'lodash.get';
import cx from 'classnames';
import DrawerTrigger from './DrawerTrigger';
import Icon from '../../Icon';
import Tabs from '../../Tabs';
import {
  MENU,
  MINIMISED_MENU,
  MENU_CONTAINER } from
'../styles/drawer';
import '../styles/_drawer.scss';




























export default class Drawer extends Component {


  static displayName = 'Drawer';

  static defaultProps = {
    isExpandable: true,
    align: 'left',
    minimisedWidth: 20,
    width: 320,
    showExpandOnHover: false,
    startOpen: false
  };

  constructor(props) {
    super(props);

    this.state = {
      minimised: props.isMinimised !== undefined ? props.isMinimised : !props.startOpen,
      selectedTab: props.selectedActiveTabIndex !== undefined ? props.selectedActiveTabIndex : 0,
      // $FlowFixMe there is a default isExpandable prop
      showExpand: !props.startOpen && !props.showExpandOnHover && props.isExpandable
    };

    this._menu = React.createRef();
  }

  componentDidUpdate(prevProps) {
    const { isMinimised, selectedActiveTabIndex } = this.props;

    if (isMinimised !== undefined && isMinimised !== prevProps.isMinimised) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ minimised: isMinimised });
    }

    if (selectedActiveTabIndex !== undefined &&
    selectedActiveTabIndex !== prevProps.selectedActiveTabIndex)
    {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ selectedTab: selectedActiveTabIndex });
    }
  }

  toggleMinimiseState = () => {
    this.setState(
      (prevState) => ({ minimised: !prevState.minimised }),
      () => {
        const { onToggleExpanded } = this.props;
        const { minimised } = this.state;

        if (onToggleExpanded) {
          onToggleExpanded(!minimised);
        }
      }
    );
  };

  setTabIndex = (params) => {
    const { onTabSelect } = this.props;
    const { selectedTabIndex } = params;
    this.setState({ selectedTab: selectedTabIndex });
    if (typeof onTabSelect === 'function') {
      onTabSelect(selectedTabIndex);
    }
  };

  onMouseOver = () => {
    const { showExpand } = this.state;
    const { isExpandable } = this.props;

    if (showExpand || !isExpandable) {return;}

    this.setState({ showExpand: true });
  };

  onMouseOut = ({ relatedTarget }) => {
    const isMenu = _get(this._menu, 'current') && relatedTarget &&
    this._menu.current.contains(relatedTarget);
    const { showExpand } = this.state;
    const { showExpandOnHover } = this.props;

    if (isMenu || !showExpand || !showExpandOnHover) {return;}

    this.setState({ showExpand: false });
  };

  static DrawerTrigger = DrawerTrigger;

  render() {
    const {
      menuColor,
      minimisedWidth,
      align,
      tabs,
      isExpandable,
      isInsidePage,
      isAnonymous,
      renderChildrenMinimised,
      children: originalChildren,
      width = 0,
      aboveContent,
      className
    } = this.props;
    const { minimised, selectedTab, showExpand } = this.state;
    const hasMultipleChildren = Children.count(originalChildren) > 1;
    const children = tabs && originalChildren && hasMultipleChildren ?
    Array.from(originalChildren) :
    originalChildren;

    return (
      <>
        <div
          ref={this._menu}
          role="button"
          className={cx(
            'drawer',
            `drawer--${align}-align`,
            MENU_CONTAINER({ width }),
            {
              'drawer--above-content': aboveContent,
              [MINIMISED_MENU({ minimisedWidth })]: minimised,
              'drawer--minimised': minimised
            },
            className
          )}
          onMouseOver={this.onMouseOver}
          onMouseOut={this.onMouseOut}
          onFocus={this.onMouseOver}
          onBlur={this.onMouseOut}
          tabIndex={0}>

          <div
            className={cx(
              'drawer__menu',
              MENU(
                menuColor,
                align,
                width,
                false,
                { hideBorder: minimised && minimisedWidth === 0 || Boolean(aboveContent) }
              ),
              {
                [MINIMISED_MENU({ minimisedWidth })]: minimised
              },
              {
                'drawer__menu--inside-page__anonymous': isAnonymous
              },
              {
                'drawer__menu--inside-page': isInsidePage
              }
            )}>

            {
            aboveContent && !minimised ?

            <Icon
              className="drawer__menu__close"
              name="close"
              color="regent"
              onClick={this.toggleMinimiseState}
              hoverColor="denim"
              size={15} /> :


            null}

            {
            isExpandable ?

            <button
              type="button"
              className={cx(
                'drawer__menu__expand-btn',
                `drawer__menu__expand-btn--${align}-align`,
                {
                  'drawer__menu__expand-btn--visible': showExpand
                }
              )}
              onClick={this.toggleMinimiseState}>

                    <Icon
                name={
                minimised && align === 'left' || !minimised && align === 'right' ?
                'chevronright' :
                'chevronleft'}

                size={10}
                color="denim" />

                  </button> :

            null}

            {
            tabs && (renderChildrenMinimised || !minimised) ?

            <Tabs updateSelectedTabIndex={this.setTabIndex} selectedIndex={selectedTab}>
                    {
              hasMultipleChildren ?
              children.filter(Boolean).
              map(
                (child, index) => cloneElement(
                  child, { title: tabs[index] }
                )
              ) :
              cloneElement(children, { title: tabs[0] })}

                  </Tabs> :
            null}

            {!tabs && (renderChildrenMinimised || !minimised) ? children : null}
          </div>
        </div>
        {
        aboveContent ?

        <button
          type="button"
          onClick={this.toggleMinimiseState}
          className={cx('drawer__overlay', { 'drawer__overlay--visible': !minimised })} /> :


        null}

      </>);

  }
}